import Image from "../../../../Elements/Image/Image";
import { useContent } from "contexts/contentContext/contentContext";
import parse from "html-react-parser";
import { useParams, useSearchParams } from "react-router-dom";
import type { PackageTypeRouteT, PeriodTypeT } from "../../models/models";
import usePurchases from "../../hooks/usePurchases";

import styles from "./styles.module.scss";

const PurchaseSideDetails = () => {
  const { packageType: packageTypeUrlParam } = useParams<{
    packageType: PackageTypeRouteT;
    periodType: PeriodTypeT;
  }>();
  const { getTextByKey } = useContent();
  const { plans } = usePurchases();
  const [searchParams] = useSearchParams();
  const packageTypeSearchParam = searchParams.get("packageType") || "";

  // Select package type from URL parameter or search parameter (if it is checkout page)
  const packageType: PackageTypeRouteT = (packageTypeSearchParam ||
    packageTypeUrlParam) as PackageTypeRouteT;

  if (
    packageTypeUrlParam === "purchase-result" ||
    packageTypeUrlParam === "purchase-complete" ||
    packageTypeUrlParam === "purchase-downgrade-success"
  ) {
    return <></>;
  }

  return (
    <div className={styles.purchaseSideDetails}>
      <h3>
        {packageType === "pay-as-you-go"
          ? getTextByKey("code-side-details-title")
          : packageType === "extra-storage" || packageType === "sub-users"
          ? getTextByKey(`${packageType}-side-details-title`)
          : plans?.find((plan) => plan.Subscription_SystemName === packageType)
              ?.Subscription_Title}
      </h3>
      {packageType !== "purchase-failed"
        ? parse(
            getTextByKey(
              `purchase-details-${
                packageType === "pay-as-you-go" ? "codes" : packageType
              }`
            )
          )
        : null}
      <div className={styles.footerSideDetails}>
        <div className={styles.sslContainer}>
          <Image name="purchases/ssl-icon" ext="png" />
          <h3 className={styles.sslText}>{getTextByKey("secure-buy")}</h3>
        </div>
        <div className={styles.acceptCardsText}>
          {getTextByKey("accepted-credit-cards")}
        </div>
        <div className={styles.cardsImage}>
          <Image
            name="purchases/cards"
            ext="png"
            title={getTextByKey("payment-methods")}
          />
        </div>
      </div>
    </div>
  );
};

export default PurchaseSideDetails;
